module.exports = __webpack_public_path__ + "76d5f11afd88a799653edc448c331742.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/01GoldenCityHafenbar.jpg
// module id = 610
// module chunks = 0